export enum NotRecommendedReasons {
  SIZE = 'size',
  TERRITORY = 'territory',
  NEUTERED = 'neutered',
  LIFESTAGE = 'lifestage',
}
